import React, { useRef, useState } from 'react';
import { FiUpload } from 'react-icons/fi';
import toast from 'react-hot-toast';
import api from '../../utils/api';

interface Props {
  phoneNumberId: string;
	onUploadSuccess?: (doc: any) => void;
}

const PortingDocumentUploader: React.FC<Props> = ({ phoneNumberId, onUploadSuccess }) => {
	const inputRef = useRef<HTMLInputElement | null>(null);
  const [isUploading, setIsUploading] = useState(false);

	const handleSelect = () => inputRef.current?.click();

	const handleFiles = async (files: FileList | null) => {
		if (!files || files.length === 0) return;
		try {
			setIsUploading(true);
			// Fetch phone number details to obtain portingRequestId
			const pn = await api.get(`/phone-numbers/${phoneNumberId}`);
			const requestId = pn.data?.portingRequest?.id;
			if (!requestId) {
				toast.error('No active porting request');
      return;
    }
			const form = new FormData();
			Array.from(files).forEach((f) => form.append('documents', f));
			// Map all files as OTHER unless UI provides types; backend accepts array alignment
			Array.from(files).forEach(() => form.append('documentTypes', 'OTHER'));
			const resp = await api.post(`/phone-numbers/porting/${requestId}/documents`, form, {
				headers: { 'Content-Type': 'multipart/form-data' }
			});
			toast.success('Documents uploaded');
			if (onUploadSuccess && resp.data?.documents?.length) {
				resp.data.documents.forEach((d: any) => onUploadSuccess(d));
			}
		} catch (e) {
			console.error('Upload failed', e);
			toast.error('Upload failed');
		} finally {
      setIsUploading(false);
    }
  };

  return (
		<div>
			<input
				ref={inputRef}
				type="file"
				multiple
				accept=".txt,.png"
				className="hidden"
				onChange={(e) => handleFiles(e.target.files)}
			/>
      <button 
				onClick={handleSelect}
				disabled={isUploading}
				className={`px-4 py-2 rounded bg-blue-600 hover:bg-blue-700 text-white inline-flex items-center gap-2 ${isUploading ? 'opacity-60 cursor-not-allowed' : ''}`}
			>
				<FiUpload />
				{isUploading ? 'Uploading...' : 'Upload Documents'}
      </button>
    </div>
  );
};

export default PortingDocumentUploader;
